import { DpIndexBar, DpEmpty } from '@/libs/components'
import { List, IndexBar } from 'antd-mobile'
import HotTag from "./hot"
import { orderBySource } from './enum'
import styles from '../index.scss'

interface DataType {
  name?: string
  code?: string
  phonePre?: string
}

const IndexBarContainer = (props) => {
  return (
    <DpIndexBar
      {...props}
      header={ props?.headerData ? () => { // IndexBar会自动将热门放在后面，所以先直接固定两种数据，可以扩展多种，暂时只有热门
        return (
          Object.keys(props?.headerData)?.map(group => {
            return (
              <IndexBar.Panel
                index={group}
                title={group}
                key={group}
              >
                <HotTag onChange={props?.onChange} data={props?.headerData?.[group] || []} />
              </IndexBar.Panel>
            )
          })
        )
      } : undefined}
      dataSource={props?.data}
      rowKey={props?.rowKey || 'code'}
      renderItem={(item: DataType) => (
        <List.Item
          key={item?.code}
          onClick={() => props?.onChange?.(item)}
          style={{ background: 'transparent' }}
        >
          <span className={styles['dp-location-select--item-city']}>
            {item.name}
          </span>
          {
            item?.phonePre && <span className={styles['dp-location-select--item-country']}>（{item.phonePre}）</span>
          }
        </List.Item>
      )}
    />
  )
}

const LocationTabs = (props: any) => {
  if (props?.data?.length === 0) {
    return <DpEmpty emptyTips={'未找到可选数据'} />
  }
  const _hotSource = (props?.data || [])?.filter(_ => ['B51', 'B88', 'B121', 'B203']?.includes(_.code))
  
  return (
    <IndexBarContainer
      onChange={props?.onChange}
      headerData={_hotSource?.length ? {[`热门`]: _hotSource } : undefined}
      data={orderBySource((props?.data || [])?.filter(_ => !['B51', 'B88', 'B121', 'B203']?.includes(_.code)))}
      style={{
        height: 'calc(100vh - 202px)',
        background: 'var(--content-bg-color, #ffffff)',
        padding: 0
      }}
    />
  )
}

export default LocationTabs
